import React, { Component } from 'react'
import config from '../../config';
import $ from 'jquery';
import { connect } from 'react-redux';
import { DISPATCH_ID, SERVICE_RESPONSE, json } from '../../libs/utils/Const';
import { NavBar, GenericTable, BreadCumb, TimeOut, ReferralSystemPerson, SearchPartnerRefSys } from '../../components';
import { ApiClient } from "../../libs/apiClient";
import { PartnerAmbassador, UserFields, ContactPersons, Addresses } from "../../components/NewOrder";

const apiClient = ApiClient.getInstance();

const headers = [
    { title: "Código" },
    { title: "Nombre" },
    { title: "Saldo" },
    { title: "Tipo" },
    { title: "Grupo" },
    { title: "Moneda" },
    { title: "RUT" },
    { title: "ACCIONES" },
];

class Ambassadors extends Component {

    constructor(props) {
        super(props)
        this.state = {
            headers: headers
            , _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
            , data: []
            , ambassadorModalAction: 1
            , ambassadorModel: new PartnerAmbassador()
            , billingResponseArray: []
            , showAmbassadorModal: false
            , enableSearchPartner: false

        };
    }

    componentDidMount = () => {
        this.SearchAmbassadors()
    }



    SearchAmbassadors = async () => {
        const { enableSpinner } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.getAmbassadors();
        enableSpinner(false);

        if (responseApi.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                data: responseApi.data ?? [],
            });

        }
    }

    // GENERAL FUNCTIONS
    RefreshModel = (model) => {
        this.setState({
            ambassadorModel: model
        })
    };

    // CREATE
    NewAmbassador = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user } = this.state

        if (!_user || _user.FMB_Role !== 'admin1') {
            showAlert({ type: 'error', message: 'No cuentas con permiso para realizar esta acción', timeOut: 5000 });
            return;
        }

        enableSpinner(true);
        let ambassadorModel = new PartnerAmbassador();
        let userFieldsService = await apiClient.getUserFields({ name: 'OCRD' });
        userFieldsService = userFieldsService.data.header || [];
        let userFields = new UserFields();

        json.userFieldsPartners.forEach((item, index) => {
            const matchedField = userFieldsService.find(userfieldItem => item.fieldId === userfieldItem.header.FieldID);
            if (matchedField) {
                const { header, options } = matchedField;
                Object.assign(item, {
                    name: header.Descr,
                    fieldType: options.length ? 2 : item.fieldType,
                    options,
                    IdValue: index
                });

                if (item.fieldType === 2) {
                    item.options.push({ FldValue: "", Descr: "" });
                }

                userFields = this.setUserFieldValue(userFields, index, header);
            }
        });

        ambassadorModel.userFields = userFields;
        this.setState({
            ambassadorModel,
            ambassadorModalAction: 1,
            showAmbassadorModal: true,
        });

        $('#BussinesPartner').modal({ backdrop: 'static', keyboard: false }, 'show');
        enableSpinner(false);
    };

    validateNull = (value) => (value === 0 ? 0 : (value || "").toString().trim());

    setUserFieldValue = (userFields, index, header) => {
        // Función auxiliar para evaluar condiciones especiales
        const validateField = (field, specialCondition = false) => {
            return specialCondition && !['inventoryRevaluation', 'bussinesPartner', 'administratorUsers', 'figuresTransport', 'transports', 'consignmentNote'].includes('bussinesPartner')
                ? field !== '' ? this.validateNull(field) : '99'
                : this.validateNull(field);
        };
        // Obtener el nombre del campo dynamic
        const fieldName = `userFields${index + 1}`;
        const headerField = header[fieldName];
        // Asignar el valor validado al campo correspondiente
        userFields[fieldName] = validateField(headerField, [20, 22, 24].includes(index));
        return userFields;
    };

    SendBusinessPartnerModel = async partnerModel => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const data = {
            model: partnerModel,
        };

        let responseArray = [];
        enableSpinner(true);
        const response = await apiClient.createBusinessPartner(data);
        enableSpinner(false);
        try {
            responseArray.push({
                docNum: response.data ? response.data.DocNum : '',
                billing: response.data ? response.data.docNumBilling : '',
                message: response.message ? response.message : '',
            });
        } catch (e) {
            responseArray.push({
                docNum: '',
                billing: '',
                message: '',
            });
        }

        this.setState({
            billingResponseArray: responseArray,
        })

        $('#billingResponseModal').modal('show');

        if (response.status === 1) {
            $('#BussinesPartner').modal('hide');
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }
    };

    // SHOW 
    OpenBusinessPartnerDetails = async (register, edit = null) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.getPartnerDetails(register.CardCode);
        enableSpinner(false);

        if (responseApi.status === SERVICE_RESPONSE.SUCCESS) {
            const newOrderModel = this.fillBusinessPartnerDetailsModel(responseApi);
            this.setState({
                ambassadorModel: newOrderModel,
                ambassadorModalAction: 2, // show
                showAmbassadorModal: true,
            });

            $('#BussinesPartner').modal({ backdrop: 'static', keyboard: false }, 'show');
            // this.bussinesPartnerModal.setState({
            //     editMode: false
            // });
            return;
        }

        showAlert({ type: 'error', message: responseApi.message });
    }

    fillBusinessPartnerDetailsModel = (model) => {
        let partnerModel = new PartnerAmbassador();
        const partner = model.data.partner;
        let userFieldsService = model.data.userFields;
        let contactPersons = model.data.contactPersons;
        let deliveriesAddress = model.data.deliveriesAddress;
        let invoicesAddress = model.data.invoicesAddress;
        let PayMethodCodes = model.data.methodsList;
        let BankAccounts = model.data.BankAccounts;

        let userFields = new UserFields();
        json.userFieldsPartners.map((item, index) => {
            userFieldsService.map(userfieldItem => {
                if (item.fieldId === userfieldItem.header.FieldID) {
                    item.name = userfieldItem.header.Descr;
                    item.fieldType = userfieldItem.options.length != 0 ? 2 : item.fieldType;
                    item.options = userfieldItem.options;
                    item.IdValue = index;
                    let newUserFields = this.setUserFieldValue(userFields, index, partner);
                    if (item.fieldType === 2) {
                        item.options.push({ FldValue: "", Descr: "" });
                    }
                    userFields = newUserFields;
                }
            });
        });

        partnerModel.userFields = userFields;
        partnerModel.U_FMB_AMBASSADOR = partner?.U_FMB_AMBASSADOR ?? 'N'
        partnerModel.U_FMB_EMAIL_AMBASSADOR = partner?.U_FMB_EMAIL_AMBASSADOR ?? ''
        partnerModel.U_FMB_PASS_AMBASSADOR = partner?.U_FMB_PASS_AMBASSADOR ?? ''
        partnerModel.update = 1;
        partnerModel.CardCode = partner.CardCode;
        partnerModel.CardName = partner.CardName || '';
        partnerModel.GroupCode = partner.GroupCode || '';
        partnerModel.GroupCodeName = partner.GroupName || '';
        partnerModel.Balance = partner.Balance || 0;
        partnerModel.DocCur = partner.Balance || '';
        partnerModel.PayMethodCodes = PayMethodCodes || [];
        partnerModel.DNotesBal = partner.DNotesBal || 0;
        partnerModel.OrdersBal = partner.OrdersBal || 0;
        partnerModel.validFor = partner.validFor || 'N';
        partnerModel.CardType = partner.CardType || '';
        partnerModel.CardTypeName = partner.CardType === 'C' ? 'Cliente' : partner.CardType === 'S' ? 'Proveedor' : 'Lead';
        partnerModel.Currency = partner.Currency || '';
        partnerModel.CurrencyName = partner.CurrencyName || '';
        partnerModel.LicTradNum = partner.LicTradNum || '';
        partnerModel.Phone1 = partner.Phone1 || '';
        partnerModel.Phone2 = partner.Phone2 || '';
        partnerModel.E_mail = partner.E_Mail || '';
        partnerModel.SlpCode = partner.SlpCode || '';
        partnerModel.SlpName = partner.SlpName || '';
        partnerModel.GroupNum = partner.GroupNum || '';
        partnerModel.GroupNumName = partner.GroupNumName || '';
        partnerModel.PriceListNum = partner.ListNum || '';
        partnerModel.PriceListNumName = partner.PriceListNumName || '';
        partnerModel.CreditLine = partner.CreditLine || 0;
        partnerModel.DebtLine = partner.DebtLine || 0;
        partnerModel.Territory = partner.Territory || '';
        partnerModel.TerritoryName = partner.TerritoryName || '';
        partnerModel.CntctPrsn = partner.CntctPrsn || '';
        partnerModel.ShipToDef = partner.ShipToDef || '';
        partnerModel.BillToDef = partner.BillToDef || '';
        partnerModel.PymCode = partner.PymCode || '';
        partnerModel.PymCodeName = partner.PymCodeName || '';
        partnerModel.RefDetails = partner.RefDetails || '';
        partnerModel.TaxCode = partner.TaxCode || '';
        partnerModel.TaxName = partner.TaxName || '';
        partnerModel.DebPayAcct = partner.DebPayAcct || '';
        partnerModel.DebPayAcctName = partner.DebPayAcctName || '';
        partnerModel.FatherType = partner.FatherType || '';
        partnerModel.VatStatus = partner.VatStatus || '';
        partnerModel.BankAccounts = BankAccounts || [];
        partnerModel.BankCountr = partner.BankCountr || '';
        partnerModel.BankCode = partner.BankCode || '';
        partnerModel.DefaultBankCode = partner.DefaultBankCode || '';
        partnerModel.DflAccount = partner.DflAccount || '';
        partnerModel.DflSwift = partner.DflSwift || '';
        partnerModel.DflBranch = partner.DflBranch || '';
        partnerModel.BankCtlKey = partner.BankCtlKey || '';
        partnerModel.DflIBAN = partner.DflIBAN || '';
        // fields to downpayments
        partnerModel.DownPaymentClearAct = partner.DpmClear || '';
        partnerModel.DownPaymentInterimAccount = partner.DpmIntAct || '';
        partnerModel.U_PTruper = partner.U_PTruper || '';
        partnerModel.U_Ppago = Number(partner.U_Ppago || '0').toFixed(2);


        let contactPersonArray = [];
        let deliveriesArray = [];
        let invoicesArray = [];
        contactPersons.map((contact, index) => {
            let newContact = new ContactPersons();
            newContact.Name = contact.Name || '';
            newContact.Active = contact.Active || '';
            newContact.FirstName = contact.FirstName || '';
            newContact.Title = contact.Title || '';
            newContact.MiddleName = contact.MiddleName || '';
            newContact.Position = contact.Position || '';
            newContact.LastName = contact.LastName || '';
            newContact.Tel1 = contact.Tel1 || '';
            newContact.Tel2 = contact.Tel2 || '';
            newContact.Cellolar = contact.Cellolar || '';
            newContact.Fax = contact.Fax || '';
            newContact.E_MailL = contact.E_MailL || '';
            newContact.Notes1 = contact.Notes1 || '';
            newContact.Notes2 = contact.Notes2 || '';

            contactPersonArray.push(newContact);
            if (partnerModel.CntctPrsn === contact.Name) {
                partnerModel.contactEditIndex = index;
            }
        });

        invoicesAddress.map((address, index) => {
            let newAddress = new Addresses();

            newAddress.Address = address.Address || '';
            newAddress.Street = address.Street || '';
            newAddress.Block = address.Block || '';
            newAddress.City = address.City || '';
            newAddress.ZipCode = address.ZipCode || '';
            newAddress.County = address.County || '';
            newAddress.State = address.State || '';
            newAddress.Country = address.Country || '';
            newAddress.TaxCode = address.TaxCode || '';
            newAddress.StreetNo = address.StreetNo || '';
            newAddress.Building = address.Building || '';
            newAddress.GlblLocNum = address.GlblLocNum || '';
            newAddress.TaxOffice = address.TaxOffice || '';
            newAddress.TypeOfAddress = address.AdresType || '';

            invoicesArray.push(newAddress);
            if (partnerModel.BillToDef === address.Address) {
                partnerModel.invoicesAddressEditIndex = index;
            }
        });

        deliveriesAddress.map((address, index) => {
            let newAddress = new Addresses();

            newAddress.Address = address.Address || '';
            newAddress.Street = address.Street || '';
            newAddress.Block = address.Block || '';
            newAddress.City = address.City || '';
            newAddress.ZipCode = address.ZipCode || '';
            newAddress.County = address.County || '';
            newAddress.State = address.State || '';
            newAddress.Country = address.Country || '';
            newAddress.TaxCode = address.TaxCode || '';
            newAddress.StreetNo = address.StreetNo || '';
            newAddress.Building = address.Building || '';
            newAddress.GlblLocNum = address.GlblLocNum || '';
            newAddress.TaxOffice = address.TaxOffice || '';
            newAddress.TypeOfAddress = address.AdresType || '';

            deliveriesArray.push(newAddress);
            if (partnerModel.ShipToDef === address.Address) {
                partnerModel.deliveriesAddressEditIndex = index;
            }
        });

        partnerModel.ContactPersons = contactPersonArray;
        partnerModel.DeliveriesAddress = deliveriesArray;
        partnerModel.InvoicesAddress = invoicesArray;
        return partnerModel;
    };

    // UPDATE
    UpdateAmbassador = async model => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ambassadorModel, _user } = this.state;
        // let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || {};

        const data = {
            model: ambassadorModel,
            email: _user.E_Mail
        };

        enableSpinner(true);
        const response = await apiClient.updateBusinessPartner(data);
        enableSpinner(false);

        let responseArray = [];

        try {
            responseArray.push({
                docNum: response.data ? response.data.DocNum : '',
                billing: response.data ? response.data.docNumBilling : '',
                message: response.message ? response.message : '',
            });
        } catch (e) {
            responseArray.push({
                docNum: '',
                billing: '',
                message: '',
            });
        }

        if (response.status === 0) {
            $('#billingResponseModal').modal('show');
            this.setState({
                billingResponseArray: responseArray,
            })
        }

        if (response.status === 1) {
            await this.OpenBusinessPartnerDetails(ambassadorModel.CardCode);
            showAlert({ type: 'success', message: response.message });
        }
    }

    OpenSearchPartner = async () => {
        await this.setState({
            enableSearchPartner: true
        });

        $('#searchPartnerRefSys').modal('show');
    }

    SearchPartnerCloseAct = async () => {
        await this.setState({
            enableSearchPartner: false
        });
    }

    ReceiveInfoByInfo = async (info) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        const data = {
            CardCode: info.CardCode,
        };

        enableSpinner(true);
        const responseApi = await apiClient.converToAmbassador(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: responseApi.message, timeOut: 9999 });
            return
        }

        showAlert({ type: 'success', message: responseApi.message, timeOut: 10000 });
        $('#searchPartnerRefSys').modal('hide');
        await this.setState({
            enableSearchPartner: false
        })
        this.SearchAmbassadors()

    }

    render() {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { headers, data, _user, ambassadorModel, ambassadorModalAction } = this.state
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'EMBAJADORES'} url1={'#'} />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <label className="text-muted">EMBAJADORES</label>
                    </h2>
                    <div className="row mb-3">
                        <div className="col-12 col-md-5 mb-3">
                            <button className="btn btn-timbra-one btn-outline-secondary mr-sm-2 mb-3 btnNuevo" onClick={this.NewAmbassador} disabled style={{ borderColor: "#A7A6A5" }} >
                                <i className="far fa-user me-1"></i> Crear embajador
                            </button>
                            <button className="btn btn-active mb-3 ml-2" onClick={() => this.OpenSearchPartner()}
                                style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da" }}>
                                <i className="fa fa-address-book-o"></i>
                            </button>
                            <button className="btn btn-outline-dark mb-3 ml-2" onClick={() => this.SearchAmbassadors()} > <i className="fa fa-refresh" /> </button>
                        </div>
                    </div>

                    {this.state.enableSearchPartner &&
                        <SearchPartnerRefSys
                            showAlert={showAlert}
                            enableSpinner={enableSpinner}
                            actionLabel={"Convertir a \nembajador"}
                            typeSearch={"SearchPossibleAmbassadors"}
                            closeAction={this.SearchPartnerCloseAct}
                            ReceiveFather={this.ReceiveInfoByInfo}
                        />
                    }

                    <GenericTable
                        headers={headers}
                        data={data}
                        view={'ambassadors'}
                        enableSearchInTable={true}
                        action={this.OpenBusinessPartnerDetails}
                    />

                    {this.state.showAmbassadorModal &&
                        <ReferralSystemPerson
                            view={'bussinesPartner'}
                            auxView={'ambassador'}
                            partnerModel={ambassadorModel}
                            action={ambassadorModalAction}
                            showAlert={showAlert}
                            enableSpinner={enableSpinner}
                            writeAccess={true}
                            refreshModel={this.RefreshModel}
                            sendModel={this.SendBusinessPartnerModel}
                            acceptEditMode={this.UpdateAmbassador}
                            cancelEditMode={this.CancelEditModePartner}
                            billingResponseArray={this.state.billingResponseArray}
                        // ref={(ref) => this.bussinesPartnerModal = ref}
                        />}

                </div>
            </div>
        )
    }


}


const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Ambassadors);
